// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"pagination_Wrapper__0iVc3","Wrapper_fixed":"pagination_Wrapper_fixed__PUsMa","Wrapper_static":"pagination_Wrapper_static__YPs5f"};